import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUser, MAINTENANCE_ASPECT_TYPE, MaintenanceAspect, RefCode } from 'assets-model';
import { MaintenanceAspectDataSource, MaintenanceAspectService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class MaintenanceAspectSearchComponentBase extends CrudListComponent<MaintenanceAspect, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'aspectAssetId', 'lockVersion', 'maintenanceType', 'periodicMaintenance', 'periodicMaintenanceDays', 'routineMaintenance', 'routineMaintenanceDays', 'visualInspection', 'actions'];

  public searchForm: FormGroup;

  aspectAssetIdFilter: number;
  @ViewChild('aspectAssetIdFilterInput') aspectAssetIdFilterInput: ElementRef;

  maintenanceTypeSelectionList: RefCode[];
  maintenanceTypeFilter: string;
  @ViewChild('maintenanceTypeFilterInput') maintenanceTypeFilterInput: MatSelect;

  periodicMaintenanceFilter: boolean;
  @ViewChild('periodicMaintenanceFilterInput') periodicMaintenanceFilterInput: MatSelect;

  periodicMaintenanceDaysFilter: number;
  @ViewChild('periodicMaintenanceDaysFilterInput') periodicMaintenanceDaysFilterInput: ElementRef;
  periodicMaintenanceDaysLessThanFilter: number;
  @ViewChild('periodicMaintenanceDaysLessThanFilterInput') periodicMaintenanceDaysLessThanFilterInput: ElementRef;
  periodicMaintenanceDaysLessThanOrEqualToFilter: number;
  @ViewChild('periodicMaintenanceDaysLessThanOrEqualToFilterInput') periodicMaintenanceDaysLessThanOrEqualToFilterInput: ElementRef;
  periodicMaintenanceDaysGreaterThanFilter: number;
  @ViewChild('periodicMaintenanceDaysGreaterThanFilterInput') periodicMaintenanceDaysGreaterThanFilterInput: ElementRef;
  periodicMaintenanceDaysGreaterThanOrEqualToFilter: number;
  @ViewChild('periodicMaintenanceDaysGreaterThanOrEqualToFilterInput') periodicMaintenanceDaysGreaterThanOrEqualToFilterInput: ElementRef;

  routineMaintenanceFilter: boolean;
  @ViewChild('routineMaintenanceFilterInput') routineMaintenanceFilterInput: MatSelect;

  routineMaintenanceDaysFilter: number;
  @ViewChild('routineMaintenanceDaysFilterInput') routineMaintenanceDaysFilterInput: ElementRef;
  routineMaintenanceDaysLessThanFilter: number;
  @ViewChild('routineMaintenanceDaysLessThanFilterInput') routineMaintenanceDaysLessThanFilterInput: ElementRef;
  routineMaintenanceDaysLessThanOrEqualToFilter: number;
  @ViewChild('routineMaintenanceDaysLessThanOrEqualToFilterInput') routineMaintenanceDaysLessThanOrEqualToFilterInput: ElementRef;
  routineMaintenanceDaysGreaterThanFilter: number;
  @ViewChild('routineMaintenanceDaysGreaterThanFilterInput') routineMaintenanceDaysGreaterThanFilterInput: ElementRef;
  routineMaintenanceDaysGreaterThanOrEqualToFilter: number;
  @ViewChild('routineMaintenanceDaysGreaterThanOrEqualToFilterInput') routineMaintenanceDaysGreaterThanOrEqualToFilterInput: ElementRef;

  visualInspectionFilter: boolean;
  @ViewChild('visualInspectionFilterInput') visualInspectionFilterInput: MatSelect;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected maintenanceAspectService: MaintenanceAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(MAINTENANCE_ASPECT_TYPE, route, router, userStorage, dialog, maintenanceAspectService, injector);

    this.searchForm = this.fb.group({
      aspectAssetId: [null],
      maintenanceType: [null],
      periodicMaintenance: [null],
      periodicMaintenanceDaysLessThan: [null],
      periodicMaintenanceDaysLessThanOrEqualTo: [null],
      periodicMaintenanceDaysGreaterThan: [null],
      periodicMaintenanceDaysGreaterThanOrEqualTo: [null],
      periodicMaintenanceDays: [null],
      routineMaintenance: [null],
      routineMaintenanceDaysLessThan: [null],
      routineMaintenanceDaysLessThanOrEqualTo: [null],
      routineMaintenanceDaysGreaterThan: [null],
      routineMaintenanceDaysGreaterThanOrEqualTo: [null],
      routineMaintenanceDays: [null],
      visualInspection: [null]
    });
  }

  createDataSource(): CrudDataSource<MaintenanceAspect> {
    return new MaintenanceAspectDataSource(this.maintenanceAspectService);
  }

  createServiceArguments(): any {
    return {
      aspectAssetId: this.aspectAssetIdFilter,
      maintenanceType: this.maintenanceTypeFilter,
      periodicMaintenance: this.periodicMaintenanceFilter,
      periodicMaintenanceDaysLessThan: this.periodicMaintenanceDaysLessThanFilter,
      periodicMaintenanceDaysLessThanOrEqualTo: this.periodicMaintenanceDaysLessThanOrEqualToFilter,
      periodicMaintenanceDaysGreaterThan: this.periodicMaintenanceDaysGreaterThanFilter,
      periodicMaintenanceDaysGreaterThanOrEqualTo: this.periodicMaintenanceDaysGreaterThanOrEqualToFilter,
      periodicMaintenanceDays: this.periodicMaintenanceDaysFilter,
      routineMaintenance: this.routineMaintenanceFilter,
      routineMaintenanceDaysLessThan: this.routineMaintenanceDaysLessThanFilter,
      routineMaintenanceDaysLessThanOrEqualTo: this.routineMaintenanceDaysLessThanOrEqualToFilter,
      routineMaintenanceDaysGreaterThan: this.routineMaintenanceDaysGreaterThanFilter,
      routineMaintenanceDaysGreaterThanOrEqualTo: this.routineMaintenanceDaysGreaterThanOrEqualToFilter,
      routineMaintenanceDays: this.routineMaintenanceDaysFilter,
      visualInspection: this.visualInspectionFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.aspectAssetIdFilter = null;
    this.maintenanceTypeFilter = null;
    this.periodicMaintenanceFilter = null;
    this.periodicMaintenanceDaysLessThanFilter = null;
    this.periodicMaintenanceDaysLessThanOrEqualToFilter = null;
    this.periodicMaintenanceDaysGreaterThanFilter = null;
    this.periodicMaintenanceDaysGreaterThanOrEqualToFilter = null;
    this.periodicMaintenanceDaysFilter = null;
    this.routineMaintenanceFilter = null;
    this.routineMaintenanceDaysLessThanFilter = null;
    this.routineMaintenanceDaysLessThanOrEqualToFilter = null;
    this.routineMaintenanceDaysGreaterThanFilter = null;
    this.routineMaintenanceDaysGreaterThanOrEqualToFilter = null;
    this.routineMaintenanceDaysFilter = null;
    this.visualInspectionFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.aspectAssetIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.maintenanceTypeFilterInput);
    this.addSearchOnChangedSelectEventListener(this.periodicMaintenanceFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.periodicMaintenanceDaysFilterInput);
    this.addSearchOnChangedSelectEventListener(this.routineMaintenanceFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.routineMaintenanceDaysFilterInput);
    this.addSearchOnChangedSelectEventListener(this.visualInspectionFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      aspectAssetId: (value: number) => self.aspectAssetIdFilter = value,
      maintenanceType: (value: string) => self.maintenanceTypeFilter = value,
      periodicMaintenance: (value: boolean) => self.periodicMaintenanceFilter = value,
      periodicMaintenanceDaysLessThan: (value: number) => self.periodicMaintenanceDaysLessThanFilter = value,
      periodicMaintenanceDaysLessThanOrEqualTo: (value: number) => self.periodicMaintenanceDaysLessThanOrEqualToFilter = value,
      periodicMaintenanceDaysGreaterThan: (value: number) => self.periodicMaintenanceDaysGreaterThanFilter = value,
      periodicMaintenanceDaysGreaterThanOrEqualTo: (value: number) => self.periodicMaintenanceDaysGreaterThanOrEqualToFilter = value,
      periodicMaintenanceDays: (value: number) => self.periodicMaintenanceDaysFilter = value,
      routineMaintenance: (value: boolean) => self.routineMaintenanceFilter = value,
      routineMaintenanceDaysLessThan: (value: number) => self.routineMaintenanceDaysLessThanFilter = value,
      routineMaintenanceDaysLessThanOrEqualTo: (value: number) => self.routineMaintenanceDaysLessThanOrEqualToFilter = value,
      routineMaintenanceDaysGreaterThan: (value: number) => self.routineMaintenanceDaysGreaterThanFilter = value,
      routineMaintenanceDaysGreaterThanOrEqualTo: (value: number) => self.routineMaintenanceDaysGreaterThanOrEqualToFilter = value,
      routineMaintenanceDays: (value: number) => self.routineMaintenanceDaysFilter = value,
      visualInspection: (value: boolean) => self.visualInspectionFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  aspectAssetIdChanging(value: number, unsetDependents: boolean = true) {}
  
  aspectAssetIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('MAINTENANCE_TYPE').subscribe(
      data => {
        this.maintenanceTypeSelectionList = data;
      }
    );
  }

  maintenanceTypeChanging(value: string, unsetDependents: boolean = true) {}
  
  maintenanceTypeChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceChanging(value: boolean, unsetDependents: boolean = true) {}
  
  periodicMaintenanceChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  periodicMaintenanceDaysGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  periodicMaintenanceDaysGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceChanging(value: boolean, unsetDependents: boolean = true) {}
  
  routineMaintenanceChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  routineMaintenanceDaysGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  routineMaintenanceDaysGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  visualInspectionChanging(value: boolean, unsetDependents: boolean = true) {}
  
  visualInspectionChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get aspectAssetId() {
    return this.searchForm && this.searchForm.get('aspectAssetId');
  }

  get maintenanceType() {
    return this.searchForm && this.searchForm.get('maintenanceType');
  }

  get periodicMaintenance() {
    return this.searchForm && this.searchForm.get('periodicMaintenance');
  }

  get periodicMaintenanceDays() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDays');
  }

  get periodicMaintenanceDaysLessThan() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysLessThan');
  }
  
  get periodicMaintenanceDaysLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysLessThanOrEqualTo');
  }
  
  get periodicMaintenanceDaysGreaterThan() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysGreaterThan');
  }
  
  get periodicMaintenanceDaysGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('periodicMaintenanceDaysGreaterThanOrEqualTo');
  }

  get routineMaintenance() {
    return this.searchForm && this.searchForm.get('routineMaintenance');
  }

  get routineMaintenanceDays() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDays');
  }

  get routineMaintenanceDaysLessThan() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysLessThan');
  }
  
  get routineMaintenanceDaysLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysLessThanOrEqualTo');
  }
  
  get routineMaintenanceDaysGreaterThan() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysGreaterThan');
  }
  
  get routineMaintenanceDaysGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('routineMaintenanceDaysGreaterThanOrEqualTo');
  }

  get visualInspection() {
    return this.searchForm && this.searchForm.get('visualInspection');
  }


}



